const shareButtons = document.querySelectorAll(".share-button-container");

shareButtons.forEach((container) => {
    const trigger = container.querySelector(".share-trigger");
    const copyBtn = <HTMLButtonElement>container.querySelector(".share-copy-link");

    if (trigger) {
        trigger.addEventListener("click", () => {
            container.classList.toggle("is-open");
        });
    }

    if (copyBtn) {
        copyBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            const url = copyBtn.getAttribute("data-url") || window.location.href;

            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(url);
                }
            } catch (err) {
                console.error("Unable to copy", err);
            }
        });
    }
});

/**
 * Handle outside clicks to close any open dropdowns
 */
document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest(".share-button-container")) {
        document.querySelectorAll(".share-button-container.is-open").forEach((container) => {
            container.classList.remove("is-open");
        });
    }
});
